// extracted by mini-css-extract-plugin
export default {"-large":"MD5GGpQWApFhIjjXYg65","fontButtonContainer":"VhufQat4vcPFyR0kKl3P","selectedButtonContainer":"runnWXf6JRgW8wf6qmth","selectedFontButtonImage":"_ZkYuSqWxVxsK2ObTyrN"};